/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import { gql } from '@apollo/client'
import * as Types from '../../../../../graphql/src/lib/graphql/generated/types'
export type VehicleMissionCardHeaderFragment = {
  __typename?: 'Vehicle'
  id: string
  totalChildrenInVehicle: number | null
  totalPassengersInVehicle: number | null
  totalPassengersToPickUp: number | null
  totalWheelchairUsersInVehicle: number | null
}

export const VehicleMissionCardHeaderFragmentDoc = gql`
    fragment VehicleMissionCardHeader on Vehicle {
  id
  totalChildrenInVehicle
  totalPassengersInVehicle
  totalPassengersToPickUp
  totalWheelchairUsersInVehicle
}
    `
